import { Race } from '@app/rest-client/faxe/models';
import {createSelector, MemoizedSelector} from '@ngrx/store';
import { selectAllRace } from '@app/store/faxe/race/race.reducer';
import { getRacesState } from '@app/store/faxe/faxe-selectors';


export const selectRaceAll: MemoizedSelector<object, Race[]> = createSelector(
  getRacesState,
  selectAllRace
);

export const selectRaces = ():
  MemoizedSelector<object, Race[]> =>
  createSelector(
    getRacesState,
    selectRaceAll,
    (state, all) => all
  );

export const selectRaceByRaceGuid = (raceGuid: string):
  MemoizedSelector<object, Race> =>
  createSelector(
    getRacesState,
    selectRaceAll,
    (state, all) => all.find(r => r.raceGuid === raceGuid)
  );



